module.exports = __webpack_public_path__ + "img/ups.ed9a0fc2.svg";